import PropTypes from 'prop-types';

import { withCertificateBlueprint } from '../redux/blueprints/certificate-creation';

const blueprint = withCertificateBlueprint('dummy');

export default PropTypes.shape(Object.keys(blueprint)
  .filter(key => typeof blueprint[key] === 'function')
  .reduce((type, key) => ({ ...type, [key]: PropTypes.func }), {}));
